import React, { useState, useCallback, useEffect } from "react";
import { CrudModal, MasterTable } from "../../components/_index";
import { deleteCategory, getCategory } from "../../services/category.service";
import { Box, Button, Dialog, Typography, TextField } from "@mui/material";
import Grid from "@mui/material/Grid2";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { debounce } from "../../utils/debounce";
import ConfirmBox from "../../components/ConfirmBox/ConfirmBox";
import AddIcon from "@mui/icons-material/Add";
import { showToast } from "../../redux/Reducer/toastReducer";
import { useDispatch } from "react-redux";
import AddTicket from "./AddTicket";
import CreateTicket from "../ServiceRequest/CreateTicket";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import CloseIcon from "@mui/icons-material/Close";
import { AutoComplete } from "../../components/_index";
import { getSpecificUser } from "../../services/user.service";
import {
  deleteTicket,
  getTicket,
  updateTicket,
} from "../../services/ticket.service";
import ViewTicket from "./ViewTicket";
import moment from "moment";
const Ticket = () => {
  const [data, setData] = useState([]);
  const [tableTotalCount, setTableCount] = useState(0);
  const dispatch = useDispatch();
  const [queryParam, setQueryParam] = useState({
    search: "",
    page: 1,
    limit: 10,
    sortType: "",
    sort: "",
    isAssigned: true,
    assignedTo: "",
  });

  const [userData, setUserData] = useState([]);
  const [openLoader, setOpenLoader] = useState(false);
  const GetTicketData = async () => {
    setOpenLoader(true);
    try {
      const userId = localStorage.getItem("userId");
      const queryParams = {
        ...queryParam,
        assignedTo: userId,
      };
      const res = await getTicket(queryParams);
      const modifiedData =
        res?.data.map((e) => ({
          ...e,
          createdAtDate: moment(e?.createdAt).format("DD MMM YYYY hh:mma"),
          categoryName: e?.categoryInfo?.name,
          createdByName: e?.createdByInfo?.name,
          createdByEmail: e?.createdByInfo?.email,
        })) || [];
      setTableCount(res?.totalCount || 0);
      setData(modifiedData);
    } catch (error) {
      console.log(error);
    } finally {
      setOpenLoader(false);
    }
  };

  useEffect(() => {
    GetTicketData();
  }, [
    queryParam.search,
    queryParam.sort,
    queryParam.limit,
    queryParam.page,
    queryParam.isAssigned,
    queryParam.assignedTo,
  ]);

  useEffect(() => {
    getSpecificUser().then((res) => {
      const modifiedData = (res?.data || []).map((el) => ({
        ...el,
        label: el?.name,
      }));
      setUserData(modifiedData);
    });
  }, []);

  const columns = [
    { id: "createdAtDate", label: "Date" },
    { id: "ticketId", label: "Ticket ID" },
    { id: "createdByName", label: "Name" },
    // { id: "createdByEmail", label: "Email" },
    { id: "categoryName", label: "Category" },
    { id: "subject", label: "Subject" },
    { id: "message", label: "Mode" },
  ];

  const [openDrawer, setOpenDrawer] = useState(false);
  const [openAssignDrawer, setOpenAssignDrawer] = useState(false);
  const [openCreateDrawer, setOpenCreateDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState({});

  const tableOutputEvent = useCallback((params) => {
    setQueryParam((queryParams) => ({
      ...queryParams,
      ...params,
    }));
  }, []);

  const handleAdd = () => {
    setOpenCreateDrawer(true);
  };

  const handleTicketCreated = () => {
    setOpenCreateDrawer(false);
    GetTicketData();
  };
  const handleView = (e) => {
    // e.isView = true;
    setOpenDrawer(true);
    setSelectedData(e);
  };

  const handleEdit = (e) => {
    e.isView = false;
    setOpenDrawer(true);
    setSelectedData(e);
  };

  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [selectedDataId, setSelectedDataId] = useState(null);
  const handleDelete = (e) => {
    setSelectedDataId(e._id);
    setConfirmDeleteOpen(true);
  };

  const deleteFunction = async () => {
    try {
      const res = await deleteTicket(selectedDataId);
      setConfirmDeleteOpen(false);
      GetTicketData();
      dispatch(showToast({ message: res.message, type: "success" }));
    } catch (error) {
      console.log(error);
    }
  };

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
  };

  const debouncedHandleSearch = useCallback(
    debounce((searchText) => {
      setQueryParam((queryParams) => ({
        ...queryParams,
        search: searchText,
      }));
    }, 300),
    []
  );

  const handleSearch = (searchText) => {
    debouncedHandleSearch(searchText);
  };
  const handleAssingn = (e) => {
    // setOpenAssignDrawer(true);
    setOpenDrawer(true);
    setSelectedData(e);
  };

  const tableActionButton = [
    {
      title: "Assign",
      onClick: handleAssingn,
      btnIcon: <PersonAddIcon />,
    },
  ];

  const assignFunction = async (userId) => {
    if (userId) {
      const value = {
        assignedTo: userId,
        // assignedAt: Date.now(),
        // isAssigned: true,
        assignedBy: "679233ee747b0e64250f3f3d", // The ID of the person assigning
      };

      // Initialize the FormData
      const formData = new FormData();
      formData.append("values", JSON.stringify(value));

      try {
        await updateTicket(selectedData._id, formData);
        setOpenAssignDrawer(false);
        GetTicketData();
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <div className="mainContent">
      <Box sx={{ display: "flex", justifyContent: "space-between" }} mb={2}>
        <Box className="SearchInputBoxContainer">
          <SearchOutlinedIcon className="Search_Icon" />
          <input
            className="SearchInputBox"
            placeholder="Search here"
            onChange={(e) => handleSearch(e.target.value)}
          />
        </Box>
        <Button onClick={handleAdd} className="addButton">
          <AddIcon />
          Create Ticket
        </Button>
      </Box>
      <MasterTable
        data={data}
        columns={columns}
        isServerSide={true}
        openLoader={openLoader}
        handleView={handleView}
        // handleEdit={handleEdit}
        // handleDelete={handleDelete}
        tableActionButton={tableActionButton}
        tableTotalCount={tableTotalCount}
        tableOutputEvent={tableOutputEvent}
      />

      <Dialog
        open={openAssignDrawer}
        PaperProps={{
          style: {
            width: "100%",
            height: "fit-content",
          },
        }}
        fullWidth
        maxWidth="xs"
      >
        <CrudModal
          title={"Assign"}
          open={true}
          handleClose={() => {
            setOpenAssignDrawer(false);
          }}
          maxWidth="xs"
        >
          <Formik
            initialValues={{ assigneeId: null }}
            // validationSchema={validationSchema}
            onSubmit={(values) => assignFunction(values.assigneeId)}
          >
            {({ values, setFieldValue, errors, touched }) => {
              console.log(values, "VVVVV");
              return (
                <Form>
                  <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 12 }}>
                      <Typography className="inputLabel">
                        Name of the Assignee
                      </Typography>
                      <AutoComplete
                        options={userData}
                        clearIcon={false}
                        value={values?.assigneeId}
                        onChange={(e, v) => {
                          setFieldValue("assigneeId", v ? v._id : null);
                        }}
                        placeholder="Select user to assign"
                      />
                      {touched.userId && errors.userId && (
                        <span className="form-error">{errors.userId}</span>
                      )}
                    </Grid>
                    <Grid size={{ xs: 12 }} mt={2}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "flex-end",
                          gap: "20px",
                        }}
                      >
                        <Button
                          className="cancelButton"
                          onClick={() => setOpenAssignDrawer(false)}
                        >
                          Cancel
                        </Button>
                        <Button type="submit" className="addButton">
                          Assign
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </Form>
              );
            }}
          </Formik>
        </CrudModal>
      </Dialog>
      {openCreateDrawer ? (
        <CreateTicket
          handleClose={() => setOpenCreateDrawer(false)}
          onCreated={handleTicketCreated}
        />
      ) : null}
      {openDrawer ? (
        <ViewTicket
          open={openDrawer}
          setOpenDrawer={setOpenDrawer}
          selectedData={selectedData}
          handleCloseDrawer={handleCloseDrawer}
          formType={
            selectedData.isView ? "view" : selectedData._id ? "edit" : "add"
          }
          // formType={selectedData._id ? "edit" : "add"}
          GetTicketData={GetTicketData}
        />
      ) : null}
      <ConfirmBox
        open={confirmDeleteOpen}
        title="Are you sure you want to delete?"
        content={`You are about to delete this item`}
        confirmButton={"Delete"}
        setOpenConfirmBox={() => setConfirmDeleteOpen(false)}
        Function={deleteFunction}
      />
    </div>
  );
};

export default Ticket;
